export const CLIENT_DASHBOARD_HEADER_TEXTS = {
  WELCOME: 'Welcome, ',
  ADD_CLIENT: 'Add client',
  BACK: 'Back',
};

export const CLIENTS_DASHBOARD_TITLE = 'Clients';
